import combineReducers from 'combine-reducers-global-state';
import { addToPagination, createPagination } from 'redux/helpers/pagination';
import types from './types';

const challengeIds = (state = [], { type, payload }) => {
  switch (type) {
    case types.getChallengesSuccess:
      return payload.data;
    default:
      return state;
  }
};

const allChallengeEntrants = (state = createPagination(null, 'entrantIds'), { type, payload }) => {
  switch (type) {
    case types.getChallengeEntrantsSuccess:
      return addToPagination(state, null, payload, 'entrantIds');
    default:
      return state;
  }
};

const activityCategoryIds = (state = [], { type, payload }) => {
  switch (type) {
    case types.getActivityCategoriesSuccess:
      return payload.data;
    default:
      return state;
  }
};

const challengeReducers = combineReducers({
  activityCategoryIds,
  challengeIds,
  allChallengeEntrants,
});

export default { challenge: challengeReducers };
